<template>
  <modal-structure
    :affirmative-handler="handleAffirmative"
    :btn-ok-text="this.$t('common.register_save')"
    :btn-cancel-text="this.$t('common.cancel')"
    :show-loading="showLoading"
    :error-message="errorMessage"
    :success-message="successMessage"
  >
    <template v-slot:header>
      <h3 class="is-size-3 is-size-4-touch has-text-centered has-text-weight-bold">
        {{ $t('common.register_title') }}
      </h3>
      <h2 class="is-size-3 is-size-4-touch has-text-centered has-text-weight-bold">
        {{ $t('common.register_subtitle') }} {{ domainInfo.data }}
      </h2>
      <div
        v-if="multipleContacts"
        class="tabs is-toggle is-centered is-full-width"
      >
        <ul>
          <li
            :class="isActive('Registration')"
            @click="changeUserType('Registration')"
          >
            <a>{{ $t('domains.contacts.registration') }}</a>
          </li>
          <li
            :class="isActive('Administration')"
            @click="changeUserType('Administration')"
          >
            <a>{{ $t('domains.contacts.administration') }}</a>
          </li>
          <li
            :class="isActive('Technical')"
            @click="changeUserType('Technical')"
          >
            <a>{{ $t('domains.contacts.technical') }}</a>
          </li>
          <li
            :class="isActive('Billing')"
            @click="changeUserType('Billing')"
          >
            <a>{{ $t('domains.contacts.billing') }}</a>
          </li>
        </ul>
      </div>
      <hr>
      <p>{{ $t('domains.register.fill_out_form') }}</p>
      <div
        v-show="hasError"
        class="is-size-5 label has-text-danger has-text-centered"
      >
        <hr>
        <p>
          <font-awesome-icon
            icon="exclamation-triangle"
            class="is-medium has-text-danger"
          />
          {{ $t('common.check_inputs') }}
        </p>
      </div>
    </template>
    <template v-slot:content>
      <address-form
        v-show="showForm('Registration')"
        :data="contacts[0]"
        :disable-form="disableForm"
        :show-copy="false"
        :parse-phone="parsePhone"
        @copyContact="copyContact"
      />
      <!--
      <address-form
        v-show="showForm('Administration')"
        :data="contacts[1]"
        :disable-form="disableForm"
        :show-copy="true"
        @copyContact="copyContact"
      />
      <address-form
        v-show="showForm('Technical')"
        :data="contacts[2]"
        :disable-form="disableForm"
        :show-copy="true"
        @copyContact="copyContact"
      />
      <address-form
        v-show="showForm('Billing')"
        :data="contacts[3]"
        :disable-form="disableForm"
        :show-copy="true"
        @copyContact="copyContact"
      />
      -->
    </template>
    <template v-slot:footer />
  </modal-structure>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import ModalStructure from './ModalStructure'
import AddressForm from '@/components/MyDomains/AddressForm'
import domainregistration from '@/mixins/domain-registration'
import domainroverview from '@/mixins/domain-overview'
import businessProfile from '@/mixins/business-profile'
import tenantConfigwMixin from '@/mixins/tenant-config'

/*
Important : This component has some now unused code to work with multiple
contacts and allow to copy info from one to the other. Then they requested only one
contact so I keep the code JIC.
*/
export default {

  name: 'RegisterDomain',
  components: {
    ModalStructure,
    AddressForm
  },
  mixins: [domainregistration, domainroverview, businessProfile, tenantConfigwMixin],
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      domainInfo: Object.assign({}, this.data),
      showLoading: false,
      errorMessage: '',
      successMessage: '',
      disableForm: false,
      activeType: 'Registration',
      activeIndex: 0,
      oneContactOk: false,
      hasError: false,
      preloaded: false,
      parsePhone: false,
      contacts: [{
        firstName: '',
        lastName: '',
        title: '',
        addressLine1: '',
        addressLine2: '',
        emailAddress: '',
        companyName: '',
        telephoneNumber: '',
        faxNumber: '',
        postalCode: '',
        city: '',
        state: '',
        province: '',
        countryCode: '',
        companyPositionHeld: '',
        contactType: 'Registration',
        hasError: false,
        hasChanged: false,
        copied: false
      }/*,
      {
        firstName: '',
        lastName: '',
        title: '',
        addressLine1: '',
        addressLine2: '',
        emailAddress: '',
        companyName: '',
        telephoneNumber: '',
        faxNumber: '',
        postalCode: '',
        city: '',
        state: '',
        province: '',
        countryCode: '',
        companyPositionHeld: '',
        contactType: 'Administration',
        hasError: false,
        hasChanged: false,
        copied: false
      },
      {
        firstName: '',
        lastName: '',
        title: '',
        addressLine1: '',
        addressLine2: '',
        emailAddress: '',
        companyName: '',
        telephoneNumber: '',
        faxNumber: '',
        postalCode: '',
        city: '',
        state: '',
        province: '',
        countryCode: '',
        companyPositionHeld: '',
        contactType: 'Technical',
        hasError: false,
        hasChanged: false,
        copied: false
      },
      {
        firstName: '',
        lastName: '',
        title: '',
        addressLine1: '',
        addressLine2: '',
        emailAddress: '',
        companyName: '',
        telephoneNumber: '',
        faxNumber: '',
        postalCode: '',
        city: '',
        state: '',
        province: '',
        countryCode: '',
        companyPositionHeld: '',
        contactType: 'Billing',
        hasError: false,
        hasChanged: false,
        copied: false
      } */ ]
    }
  },
  computed: {
    ...mapState(['services', 'account']),
    ...mapGetters('domainService', ['hasRegisteredDomain']),
    multipleContacts () {
      if (this.contacts.length > 1) {
        return true
      }
      return false
    }
  },
  watch: {
    contacts: {
      handler (list) {
        for (const i in list) {
          if (list[i].hasError === false && list[i].hasChanged === true && list[i].firstName !== '' && list[i].lastName !== '' && list[i].emailAddress !== '' && list[i].telephoneNumber !== '') {
            this.oneContactOk = true
            return true
          }
        }
        this.oneContactOk = false
      },
      deep: true
    },
    businessProfile: {
      handler (profile) {
        if (profile !== null && !this.preloaded) {
          this.preloaded = true
          this.contacts[0].firstName = (profile.firstName) ? profile.firstName : ''
          this.contacts[0].lastName = (profile.lastName) ? profile.lastName : ''
          this.contacts[0].emailAddress = (profile.email) ? profile.email : ''
          this.contacts[0].companyName = (profile.businessName) ? profile.businessName : ''
          this.contacts[0].telephoneNumber = (profile.phoneNumber) ? profile.phoneNumber : ''
          this.contacts[0].addressLine1 = (profile.address.address1) ? profile.address.address1 : ''
          this.contacts[0].addressLine2 = (profile.address.address2) ? profile.address.address2 : ''
          this.contacts[0].postalCode = (profile.address.postalCode) ? profile.address.postalCode : ''
          this.contacts[0].city = (profile.address.city) ? profile.address.city : ''
          this.contacts[0].state = (profile.address.stateOrProvince) ? profile.address.stateOrProvince : ''
          this.contacts[0].province = (profile.address.county) ? profile.address.county : ''
          this.contacts[0].countryCode = (profile.address.countryCode) ? profile.address.countryCode : ''
          this.contacts[0].copied = true
        }
      }
    }
  },
  methods: {
    async handleAffirmative () {
      this.parsePhone = !this.parsePhone
      await new Promise(function (resolve, reject) {
        setTimeout(() => resolve('done'), 600)
      })

      if (this.checkContacts() && this.oneContactOk) {
        this.showLoading = true
        this.errorMessage = ''
        this.successMessage = ''
        this.disableForm = true

        const result = await this.registerDomainName(this.services.domainregistration, this.domainInfo.data, this.contacts, this.getTenantConfig('primaryDomain'))

        if (result) {
          await this.getDomainDetails(this.services.domainregistration)
          this.disableForm = false
          this.showLoading = false
          this.$root.$emit('close::custom::modal')

          if (this.hasRegisteredDomain) {
            this.$router.push({ name: 'MyDomains' })
          } else {
            this.$router.push({ name: 'DomainRegistration' })
          }
        } else {
          this.showLoading = false
          this.errorMessage = this.$t('common.register_save_fail')
          this.disableForm = false
        }
      }
    },
    changeUserType (type) {
      this.activeType = type
    },
    showForm (type) {
      if (type === this.activeType) {
        return true
      }
      return false
    },
    isActive (type) {
      if (type === this.activeType) {
        return 'is-active'
      }
      return ''
    },
    checkContacts () {
      for (const i in this.contacts) {
        if (this.contacts[i].hasChanged === true && this.contacts[i].hasError === true) {
          this.changeUserType(this.contacts[i].contactType)
          this.hasError = true
          return false
        }
      }
      return true
    },
    copyContact (type) {
      for (const i in this.contacts) {
        if (this.contacts[i].contactType === type) {
          Object.keys(this.contacts[i]).forEach(value => {
            const excluded = ['contactType', 'hasError', 'hasChanged', 'copied']
            if (excluded.includes(value) !== true) {
              if (this.contacts[i].copied === false) {
                this.contacts[i][value] = this.contacts[0][value]
              } else {
                this.contacts[i][value] = ''
              }
            }
          })
          this.contacts[i].copied = !this.contacts[i].copied
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .form {
    width: 100%;
    margin-top: auto;
    text-align: left;
  }
  .tabs {
    .is-active a {
      background-color: var(--primary-color) !important;
      border-color: var(--primary-color) !important;
    }
  }
</style>
